function objEmpty(obj) {
    for (let k in obj) {
        if (hasOwnProperty.call(obj, k)) {
            return false;
        }
    }
    return true;
}


export default {
    namespaced: true,
    state: {
        imageCounts: {},
        imageNamesAll: [],
        imagesPending: [],
        imagesSelected: [],
        imagesPublished: [],
        imagesRejected: [],
        imagesSubmitted: []
    },
    getters: {
        numberPending(state) {
            return state.imagesPending.length;
        },
        imageCounts(state) {
            return state.imageCounts;
        },
        imageNamesAll(state) {
            return state.imageNamesAll;
        },
        // Does the imageCounts property have a populated object, i.e. is the obj NON-empty?
        imageCountsLoaded(state) {
            return !objEmpty(state.imageCounts);
        },
        imagesList(state) {
            return function (imageType) {
                var stateProp = 'images' + imageType;
                return state[stateProp]
            }
        }
    },
    actions: {
        setImagesList({
            commit
        }, listObj) {
            commit('setImagesList', listObj)
        },
        setImageCounts({
            commit
        }, objImageCounts) {
            commit('setImageCounts', objImageCounts);
        },
        clearImageCounts({
            commit
        }) {
            commit('clearImageCounts');
        },
        setImageNamesAll({
            commit
        }, arrAllImageNames) {
            commit('setImageNamesAll', arrAllImageNames);
        },
        clearImageNamesAll({
            commit
        }) {
            commit('clearImageNamesAll');
        }
    },
    mutations: {
        setImagesList(state, listObj) {
            var imageType = listObj.imageType;
            var stateProp = 'images' + imageType;
            state[stateProp] = [...listObj.images];
        },
        setImageCounts(state, objImageCounts) {
            state.imageCounts = {
                ...state.imageCounts,
                ...objImageCounts
            };
            // if (objImageCounts) {
            //     state.imageCounts = { ...state.imageCounts, ...objImageCounts };
            // } else {
            //     state.imageCounts = {};
            // }
        },
        clearImageCounts(state) {
            state.imageCounts = {};
        },
        setImageNamesAll(state, arrAllImageNames) {
            state.imageNamesAll = [...arrAllImageNames];
            // if (arrAllImageNames) {
            //     state.imageNamesAll = [...arrAllImageNames];
            // } else {
            //     state.imageNamesAll = [];
            // }
        },
        clearImageNamesAll(state) {
            state.imageNamesAll = [];
        }
    }
}